(() => {
  'use strict';
  const element = document.getElementById('VellaBundleConfiguration');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const previewText = 'זו תצוגה מקדימה בלבד. המארז הזוגי ומארז השלישייה יופעלו לאחר אישור.';
  const checkoutEnabled = config.checkoutEnabled === true;
  const nativeVariant = String(config.deviceVariant);
  function notice(text = previewText) {
    let target = document.getElementById('VellaBundleStatus');
    if (!target) {
      target = document.createElement('p'); target.id = 'VellaBundleStatus';
      target.setAttribute('role', 'status'); target.tabIndex = -1;
      const picker = document.querySelector('[data-vella-offer-picker]');
      (picker || document.querySelector('main') || document.body).append(target);
    }
    target.textContent = text; target.focus({ preventScroll: false });
  }
  function mapFormData(source) {
    const result = new FormData();
    for (const [name, value] of source) result.append(name, value);
    if (String(source.get('id')) !== nativeVariant) return result;
    const quantity = Number(source.get('quantity') || 1);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 3) throw new Error('בחרי חבילה של מכשיר אחד, שניים או שלושה.');
    if (quantity === 1) return result;
    const pack = config.packs[String(quantity)];
    if (!pack || !/^\d+$/.test(String(pack.variantId))) throw new Error('החבילה אינה זמינה.');
    result.set('id', String(pack.variantId)); result.set('quantity', '1');
    result.set('properties[_vella_bundle_pack]', String(quantity));
    result.set('properties[כלול בחבילה]', `${pack.devices} מכשירים, ${pack.bags} תיקים ו-${pack.rollers} רולרים`);
    for (const name of ['properties[_vella_bag]', 'properties[_vella_roller]', 'vella_bag', 'vella_roller']) result.delete(name);
    return result;
  }
  window.VellaBundle = Object.freeze({ checkoutEnabled, mapFormData, packs: config.packs, unitPrice: config.unitPrice });
  function guard(event) {
    if (checkoutEnabled) return;
    const target = event.target instanceof Element ? event.target : null;
    const product = target?.closest('.vella-main-product');
    const quantity = Number(product?.querySelector('.quantity__input[name="quantity"]')?.value || 1);
    const buyingBundle = product && quantity > 1 && (event.type === 'submit' || target.closest('.product-form__submit, [name="add"]'));
    // Never block regular single-item purchases or unrelated cart checkouts.
    if (!buyingBundle) return;
    event.preventDefault(); event.stopImmediatePropagation(); notice();
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);
  function start() {
    const gift = window.VellaGift;
    if (gift?.add && !gift.__bundleMapped) {
      const add = gift.add.bind(gift);
      gift.add = async (data) => {
        if (!checkoutEnabled) {
          if (String(data.get('id')) === nativeVariant && Number(data.get('quantity') || 1) > 1) throw new Error(previewText);
          return add(data);
        }
        const root = document.querySelector('.vella-main-product [data-vella-unit-price]');
        if (String(data.get('id')) === nativeVariant && (Number(root?.dataset.vellaUnitPrice) !== config.unitPrice || root?.dataset.currency !== config.currency)) throw new Error('המחיר השתנה. יש לרענן את הגדרות החבילות לפני הרכישה.');
        return add(mapFormData(data));
      };
      gift.__bundleMapped = true;
    }
    document.querySelectorAll('.vella-main-product .quantity__input[name="quantity"]').forEach(input => { input.max = '3'; });
    const picker = document.querySelector('[data-vella-offer-picker]');
    if (picker && !checkoutEnabled) {
      let text = document.getElementById('VellaBundlePreview');
      if (!text) { text = document.createElement('p'); text.id = 'VellaBundlePreview'; text.className = 'caption'; picker.after(text); }
      text.textContent = 'תצוגה מקדימה בלבד — המארזים הזוגי והשלישייה יופעלו לאחר אישור.';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  // The site's gift engine is loaded after this adapter. Wait for it before
  // wrapping add-to-cart, including slow mobile connections.
  let giftHookAttempts = 0;
  function connectLateGiftEngine() {
    if (window.VellaGift?.__bundleMapped) return true;
    if (!window.VellaGift?.add) return false;
    start();
    return window.VellaGift?.__bundleMapped === true;
  }
  const giftHookTimer = window.setInterval(() => {
    if (connectLateGiftEngine() || ++giftHookAttempts >= 120) {
      window.clearInterval(giftHookTimer);
    }
  }, 100);
  window.addEventListener('load', connectLateGiftEngine, { once: true });
})();
